import React, { useContext, useState } from "react";
import { Container } from "@material-ui/core";
import PageTitle from "../../../components/pageTitle/PageTitle";
import { Link } from "react-router-dom";
import ThemeTable from "../../../components/Table/ThemeTable";
import styles from '../Report.module.scss'
import AuthContext from "../../../hooks/authContext";
import { packageAccess } from "../../../services/helpers";

function ClientReportOld(props) {

  const [filterReports, setfilterReports] = useState([]);
  const auth = useContext(AuthContext);
  const userPackageId = auth?.userProfile?.prdId;
  const allowedPermissions = packageAccess(userPackageId);

  const reportList = [
    { "name": "Shift Reports", "id": "Create", Link: "/reports/ShiftReport" },
    { "name": "Tasks Reports", "id": "Create", Link: "/reports/Taskreport" },
    { "name": "Work Site Reports", "id": "Create", Link: "/reports/Worksitereport" },
    { "name": "Issues Reports", "id": "Create", Link: "/reports/Issuesreport" },
    { "name": "Supply Reports", "id": "Create", Link: "/reports/Supplyreport" },
  ]

  const getColumns = () => {
    const columns = [];
    columns.push({
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Report Name",
      isSortable: false,
      rowclassName: styles.width25,
    });
    columns.push({
      id: "Action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      isSortable: false,
    });
    return columns;
  };

  useState(() => {
    // const hasSupplyAccess = allowedPermissions?.routes?.includes("SUPPLIES");
    // const hasIssueAccess = allowedPermissions?.routes?.includes("ISSUES");

    // const filteredReports = reportList?.filter((report) => {
    //   if (report?.name === "Supply Reports" && !hasSupplyAccess) return false;
    //   if (report?.name === "Issues Reports" && !hasIssueAccess) return false;
    //   return true;
    // });
    const filteredReports = reportList;

    setfilterReports(filteredReports);
  }, []);

  const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
    switch (hcellItem.id) {
      case 'Action':
        if (rcellItem.id === "Create") {
          return (
            <div className={styles.actions} >
              <Link to={rcellItem.Link} rel="noopener" className={` ${styles.actions} ${styles.textunderline}`}>
                Create
              </Link>
            </div>
          )
        }
        break;
      default:
        return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
    }
  }

  return (
    <>

     <Container style={{ boxSizing: "content-box", padding:0}} >
        <PageTitle
          pageTitle="Client Reports"
          showBreadcrumb={[{ label: "Home", to: "/" }, { label: "Reports" }]}
          BreadCrumbCurrentPageTitle={"Client Reports"}
          showLastSeen={true}
        ></PageTitle>


        <div className={`sectionBox summaryTableWrap ${styles.sectionbox} dark:bg-[#1A1F2C] dark:text-white shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`} >
          <div className={styles.border}>
            <ThemeTable
              rows={filterReports}
              headCells={getColumns()}
              hidePagination={true}
              renderRowCell={renderRowCell}
            />
          </div>
        </div>
      </Container>
    </>
  )

}

export default ClientReportOld;